export default "__VITE_ASSET__CeYvKbol__"